export default __webpack_public_path__ + "../staticImages/paypal.svg";